import { getYear } from "date-fns";

const range = (start, end, step = 1) => {
  const output = [];
  for (let i = start; i <= end; i += step) {
    output.push(i);
  }
  return output;
};

export const YEARS = range(1990, getYear(new Date()) + 20, 1);
export const MONTHS = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];
